// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__3GQcW","modalFooterButton":"ModalNotes_modalFooterButton__hIU_7"};